import cuid from 'cuid';
import {
  ApplicantInfo,
  Application,
  OfferInfo,
  OwnerInfo,
  RBF_PRODUCT_ID,
  TERMLOAN_PRODUCT_ID,
} from '../@types/application-types';
import { StringFormatTypes, StringVariationTypes, transformString } from './formatString';

export const GetDefaultNewOwner = (appId: string) => {
  const clientId = localStorage.getItem('clientId') || '';
  const owner: OwnerInfo = {
    clientId,
    id: `OWNER-${cuid().toUpperCase()}`,
    appId,
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    dateOfBirth: new Date(),
    SSN: '',
    percentOwnership: 0,
    homeStreetAddress1: '',
    homeStreetAddress2: '',
    city: '',
    state: '',
    zip: '',
    userDate: '',
    createdAt: new Date(),
    updatedAt: new Date(),
  };
  return owner;
};
export const GetDefaultNewApplication = (defaultClientId = 'LEAD') => {
  const clientId = localStorage.getItem('clientId') || defaultClientId;

  const appId: string = `APP-${cuid().toUpperCase()}`;
  const owner1: OwnerInfo = GetDefaultNewOwner(appId);

  const applicant: ApplicantInfo = {
    clientId,
    appId,
    productId: RBF_PRODUCT_ID,
    legalBusinessName: '',
    industry: '',
    grossAnnualSales: 0,
    requestedAmount: 0,
    purposeOfCapital: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    password: '',
    dba: '',
    entityType: '',
    businessStreetAddress1: '',
    businessStreetAddress2: '',
    businessCity: '',
    businessState: '',
    businessZip: '',
    federalTaxID: '',
    businessStartDate: undefined,
    businessPhone: '',
    averageMonthlySales: 0,
    websiteURL: '',
    acceptsCreditCards: false,
    hasCurrentShortTermFinancing: false,
    owners: [owner1],
    userDate: '',
    businessInfoEdited: false,
    basicInfoEdited: false,
    ownerInfoEdited: false,
    createdAt: new Date(),
    updatedAt: new Date(),
  };

  const newApplication: Application = {
    clientId,
    appId,
    status: 'NotSubmitted',
    createdAt: new Date(),
    updatedAt: new Date(),
    acceptedAgreements: false,
    acceptedEsignConcent: false,
    applicant,
    offers: [] as OfferInfo[],
    stips: {
      appId,
      bankStatements: [],
      driverLicence: undefined,
      voidedCheck: undefined,
    },
  };

  return newApplication;
};
export const isOpenApplication = (application: Application) =>
  !(
    application.status === 'OfferAccepted' ||
    application.status === 'Funded' ||
    application.status === 'Rejected'
  );
export const isUnsubmittedApplication = (application: Application) =>
  application.status === 'NotSubmitted';

type RBFTLDealProps = {
  productId: string | null | undefined;
  stringFormatType?: StringFormatTypes;
  stringVariationType?: StringVariationTypes;
};

export function GetPaymentOrRemittanceDescription({
  productId,
  stringFormatType = StringFormatTypes.Capitalize,
  stringVariationType = StringVariationTypes.Singular,
}: RBFTLDealProps) {
  let description = 'Remittance';

  if (productId === TERMLOAN_PRODUCT_ID) {
    description = 'Payment';
  }

  if (stringVariationType === StringVariationTypes.Plural) {
    description += 's';
  }

  return transformString(description, stringFormatType);
}

export function GetPaidOrRemittedDescription({
  productId,
  stringFormatType = StringFormatTypes.Capitalize,
}: RBFTLDealProps) {
  let description = 'Remitted';

  if (productId === TERMLOAN_PRODUCT_ID) {
    description = 'Paid';
  }

  return transformString(description, stringFormatType);
}
